import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import InputMask from 'react-input-mask';

export default function App(){      
  const [customerData, setCustomerData] = useState({
    full_name: '',
    region: '',
    city: '',
    postal_code: '',
    street: '',
    home: '',
    apartment: '',
    phone_number: '',
    kaspi_number: '',

  })
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get("redirect") || "/";
    const navigate = useNavigate();
    const token = localStorage.getItem("access_token");
    const [sameNumber, setSameNumber] = useState(false);      
    useEffect(() => {
      if (sameNumber) {
        setCustomerData((prev) => ({ ...prev, kaspi_number: prev.phone_number }));
      }
    }, [customerData.phone_number, sameNumber]);
    const handleChange = (e) => {
      e.preventDefault();
        setCustomerData({
          ...customerData,
          [e.target.name]: e.target.value,
        });
      };
      
    const handleCustomerFormSubmit = async (event) => {
      event.preventDefault();
    
      try {
        await axios.post("https://monkeprogrammer01.pythonanywhere.com/user/customer-form/", { customerData }, {
        headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',

      }
    })      
    navigate(redirectPath);

    } catch {
      console.error("Error creating order");

    }}

    return <>
    <div className="container d-flex justify-content-center min-vh-80">
    <div className="" style={{ maxWidth: '400px', width: '100%', marginTop: '1%', borderRadius: "12px"}}>
      <div className="card-body">
        <h3 className="card-title text-center mb-4">Заполните данные для заказа</h3>
          <form onSubmit={handleCustomerFormSubmit}>
              <div className="mb-3">
              <label className="form-label">ФИО</label>
              <input
                  name="full_name"
                  className="form-control"
                  placeholder="Фамилия Имя"
                  value={customerData.full_name}
                  onChange={handleChange}
                  required
                />
              </div>
                      <div className="mb-3">
                      <label className="form-label">Область</label>
                      <input
                          name="region"
                          className="form-control"
                          placeholder="Область"
                          value={customerData.region}
                          onChange={handleChange}
                          required
                      />
                      </div>
                      <div className="mb-3">
              <label className="form-label">Город</label>
              <input
                  name="city"
                  className="form-control"
                  placeholder="Город/поселок"
                  value={customerData.city}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
              <label className="form-label">Почтовый индекс</label>
              <input
                name="postal_code"
                  type="number"
                  className="form-control"
                  placeholder="Почтовый индекс"
                  value={customerData.postal_code}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">

              <label className="form-label">Улица</label>
              <input
              name="street"

                  className="form-control"
                  placeholder="Улица"
                  value={customerData.street}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
              <label className="form-label">Дом</label>
              <input
              name="home"
                  className="form-control"
                  placeholder="Дом"
                  value={customerData.home}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
              <label className="form-label">Квартира</label>
              <input
              name="apartment"
              type="number"
                  className="form-control"
                  placeholder="Квартира"
                  value={customerData.apartment}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3" >
              <div className="PhoneInput" style={{'display': 'flex'}} >
              
              <InputMask
                mask="+7 (999) 999-99-99"
                name="phone_number"
                value={customerData.phone_number}
                onChange={handleChange}
                required
              >
  {(inputProps) => <input {...inputProps} type="tel" placeholder="+7 (___) ___-__-__" />}
</InputMask>
              { !sameNumber &&               <InputMask
                mask="+7 (999) 999-99-99"
                name="kaspi_number"
                value={customerData.kaspi_number}
                onChange={handleChange}
                required
              >
  {(inputProps) => <input {...inputProps} type="tel" placeholder="+7 (___) ___-__-__" />}
</InputMask> }
    

              </div>              
              <button className="btn btn-warning w-100" onClick={(event) => {event.preventDefault(); setSameNumber(!sameNumber); setCustomerData((prev) => ({...prev,kaspi_number: prev.phone_number}))}} >{sameNumber ? "Каспи номер другой" : "У меня один и тот же номер"}</button>

              </div>
                      <button type="submit" className="btn btn-success w-100">Отправить</button>
                  </form>
                  </div>
              </div>
      </div>
    </>
}